export default __webpack_public_path__ + "static/media/Ignis.53362c86.png";